// extracted by mini-css-extract-plugin
export var formContainer = "_mm-0";
export var message = "_mm-1";